export var InitAuthSequenceResponse;
(function (InitAuthSequenceResponse) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/service/agentmanager.proto}
     */
    let InitAuthSequenceResult;
    (function (InitAuthSequenceResult) {
        InitAuthSequenceResult[InitAuthSequenceResult["UNKNOWN"] = 0] = "UNKNOWN";
        InitAuthSequenceResult[InitAuthSequenceResult["SUCCESS"] = 1] = "SUCCESS";
        InitAuthSequenceResult[InitAuthSequenceResult["NOT_AUTHORIZED"] = 2] = "NOT_AUTHORIZED";
        InitAuthSequenceResult[InitAuthSequenceResult["ERROR"] = 3] = "ERROR";
    })(InitAuthSequenceResult = InitAuthSequenceResponse.InitAuthSequenceResult || (InitAuthSequenceResponse.InitAuthSequenceResult = {}));
})(InitAuthSequenceResponse || (InitAuthSequenceResponse = {}));
//# sourceMappingURL=agentmanager.js.map